<div class="metadata-container" *ngIf="!!selection">
    <div class="card">
        <div class="card-block">
            <div class="btn-group">
                <button class="btn btn-success" (click)="checkGlossary()">Check Glossary</button>
            </div>
            <div class="btn-group">
                <button class="btn btn-success" (click)="checkReadToMeAudio()">Check Read To Me Audio</button>
            </div>
            <div class="btn-group">
                <button class="btn btn-success" (click)="checkWordAudio()">Check Word Audio</button>
            </div>
            <div class="btn-group">
                <button class="btn btn-success" (click)="checkGlossaryAudio()">Check Glossary Audio</button>
            </div>
            <div class="btn-group">
                <button class="btn btn-success" (click)="checkQuestionAudio()">Check Question Audio</button>
            </div>
            <div class="btn-group">
                <button class="btn btn-success"
                        [disabled]="checkInProgress || !errorString"
                        (click)="transitionAudioState()">Set Audio State Based on Result</button>
            </div>
            <div class="card-text" *ngIf="checkInProgress">checking...</div>
            <div class="card-text" *ngIf="saveClicked">saved audio state for:</div>
            <pre style="font-size:small" class="card-text" *ngIf="!checkInProgress && errorString">{{errorString}}</pre>
        </div>


    </div>
</div>
